import { trpc } from '@/utils/trpc'

const RUNNING_OPTIMIZATIONS_REFETCH_INTERVAL_MS = 30_000

/**
 * Running optimization jobs for a network, polled while at least one job is
 * running. Polling is a fallback for the realtime broadcast on
 * `optimization_jobs`: the completion UPDATE is the job's last write, so a
 * single missed broadcast (dropped oversized payload, websocket disconnected
 * at completion time) would otherwise leave the "Optimization running"
 * indicator stuck until a full page reload — staleTime is Infinity and there
 * is no other refetch trigger.
 */
export const useRunningOptimizations = (networkId: string) =>
  trpc.optimization.getRunningOptimizationsForNetwork.useQuery(
    { networkId },
    {
      refetchInterval: (query) =>
        query.state.data && query.state.data.length > 0
          ? RUNNING_OPTIMIZATIONS_REFETCH_INTERVAL_MS
          : false,
    },
  )

export default useRunningOptimizations
